module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAABGElEQVQ4jbWSzypEYRiHn0GKjY0LkI1sXIbJDbgM69laiJIoZUyJLMbSQhZYWCh3YGElK0sLf0ZN9OhrXhqn85lT8quvTu/7+z1f3/se1NwZU3fVjvqsbqijOX8OkgKn9nShXsX3kTpcFZSMxxFc7qtvR+1QrQ0CJUg7AmuFXgq3otcsworGZs5YctF6DrQVhv0MpOzpK0XQajTauWGWLOMkMo0vUCMKqVFXpyuAZtR59TKyS6n4pp7FLY/qZgXQgXqnjqvXancEmAUegC4wBNQYrFp4O0AdmEqg+wrB3/QC3Az9EfKtfwN9AJMVcsnz3l9IM+rXObCY3gzclgDSkOeABaD1o1NY64S6p77G/1GmJ3UnVt/LKZ9w/FjEsR9odAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sygk.png
// module id = /AUt
// module chunks = 1